import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { RouteStore, ContextStore, PageStore, AnalyticsStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { UitkEmptyState } from 'uitk-react-empty-state';

import { InformationCriteriaStore, SearchCriteriaStore } from 'stores';
import { isFightInformation, isFightsSearch, trackAnalytics } from 'utility';
import { AnalyticsType } from 'types/shared';

interface NoApiResponseProps extends LocalizedComponentProps {
  searchCriteriaStore?: SearchCriteriaStore;
  informationCriteriaStore?: InformationCriteriaStore;
  routeStore?: RouteStore;
  context?: ContextStore;
  page?: PageStore;
  analytics?: AnalyticsStore;
}

@withLocalization
@inject('context', 'searchCriteriaStore', 'routeStore', 'page', 'analytics', 'informationCriteriaStore')
@observer
export class NoApiResponse extends React.Component<NoApiResponseProps> {
  private retryOnClick = () => {
    const { searchCriteriaStore, routeStore, context, page, analytics, informationCriteriaStore } = this.props;
    let analyticsType: AnalyticsType;

    if (isFightInformation(page)) {
      analyticsType = {
        linkName: 'page.Flight.FIS.Error',
        rfrr: 'FLT.FIS.Servererror.retry.Clicked'
      };
    }
    if (analytics && analyticsType) {
      trackAnalytics(analyticsType, analytics);
    }

    if (isFightsSearch(page) && searchCriteriaStore && routeStore) {
      searchCriteriaStore.triggerSearch(routeStore, context, true, true);
    } else if (isFightInformation(page) && informationCriteriaStore && routeStore) {
      informationCriteriaStore.triggerInformation(routeStore, context, true);
    } else {
      location.reload();
    }
  };

  public render() {
    const headingText = this.props.l10n.formatText('server.error.heading');
    const bodyText = this.props.l10n.formatText('server.error.message');
    const buttonText = this.props.l10n.formatText('server.error.retry.button.text');

    return (
      <main className="uitk-type-center all-y-padding-twelve" data-test-id="no-api-response">
        <UitkEmptyState
          icon="search"
          className="all-y-padding-twelve"
          heading={headingText}
          body={bodyText}
          buttonText={buttonText}
          headingLevel="h1"
          onClick={this.retryOnClick}
        />
      </main>
    );
  }
}
